<div class="manage-outage-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="manage-outage-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="manage-outage-shell__sidebar"
    [class.manage-outage-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-outage-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-outage-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-outage-page">
      <section class="manage-outage-page__heading">
        <div class="manage-outage-page__heading-copy">
          <h2 class="app-title-serif">Manage Outage</h2>
        </div>

        <button type="button" class="app-button app-button--primary manage-outage-page__add-button" (click)="openAddOutageModal()">
          <span class="manage-outage-page__add-icon">+</span>
          <span>Add Outage</span>
        </button>
      </section>

      <section class="manage-outage-page__filters app-card">
        <form class="manage-outage-filters" [formGroup]="filterForm">
          <label class="app-form-field manage-outage-filters__field">
            <span class="app-form-label">Search by substation</span>
            <div class="manage-outage-filters__search">
              <span class="manage-outage-filters__search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <path d="m20 20-3.5-3.5"></path>
                </svg>
              </span>
              <input class="app-form-input manage-outage-filters__search-input" type="text" placeholder="Search" formControlName="search" />
            </div>
          </label>

          <div>
            <button
              type="button"
              class="app-button app-button--secondary equal app-filter-actions__button"
              (click)="clearFilters()"
            >
              Clear
            </button>
          </div>
        </form>
      </section>

      <section class="manage-outage-page__table app-card">
        <div class="manage-outage-page__table-wrap app-table-scroll">
          <table class="manage-outage-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Entity</th>
                <th>Substation</th>
                <th>Start</th>
                <th>Expected End</th>
                <th>Actual Revival</th>
                <th>Duration</th>
                <th>Type</th>
                <th>Reason</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="10" class="manage-outage-page__empty-state">Loading outages...</td>
                </tr>
              } @else if (outages.length) {
                @for (item of outages; track trackByOutageId($index, item)) {
                  <tr>
                    <td>{{ item.serial_no }}</td>
                    <td>{{ item.entity_name || getEntityName(item.mstr_entity_id) }}</td>
                    <td>{{ item.station_name }} <span class="manage-outage-table__sub-code">{{ item.station_code || '' }}</span></td>
                    <td>{{ formatOutageDate(item.outage_start, item.outage_start_bs) }}</td>
                    <td>{{ formatOutageDate(item.expected_end, item.expected_end_bs) }}</td>
                    <td>{{ formatOutageDate(item.actual_revival, item.actual_revival_bs) }}</td>
                    <td>{{ getDurationText(item) }}</td>
                    <td>{{ item.outage_type || '-' }}</td>
                    <td class="manage-outage-table__reason">{{ item.reason || '-' }}</td>
                    <td>
                      <div class="manage-outage-page__actions">
                        <div class="app-row-action-menu">
                          <details class="app-row-action-menu__details">
                            <summary class="app-row-action-menu__toggle" aria-label="Open outage actions">
                              <span class="app-row-action-menu__dots" aria-hidden="true">
                                <span></span>
                                <span></span>
                                <span></span>
                              </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewOutageModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                    <circle cx="12" cy="12" r="2.8"></circle>
                                  </svg>
                                </span>
                                <span>View</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditOutageModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                    <path d="m13.5 6.5 4 4"></path>
                                  </svg>
                                </span>
                                <span>Edit</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteOutageModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 6h18"></path>
                                    <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                    <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                    <path d="M10 10v6"></path>
                                    <path d="M14 10v6"></path>
                                  </svg>
                                </span>
                                <span>Delete</span>
                              </button>
                            </div>
                          </details>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              } @else {
                <tr>
                  <td colspan="10" class="manage-outage-page__empty-state">No outages found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (canShowPagination()) {
          <div class="manage-outage-page__pagination">
            <div class="manage-outage-page__pagination-summary">
              <span>{{ getPaginationLabel() }}</span>
            </div>

            <div class="manage-outage-page__pagination-actions">
              <button type="button" class="app-button app-button--secondary manage-outage-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                Previous
              </button>

              <div class="manage-outage-page__pagination-pages" aria-label="Pagination pages">
                @for (page of getPaginationItems(); track $index) {
                  @if (page === -1) {
                    <span class="manage-outage-page__pagination-ellipsis" aria-hidden="true">...</span>
                  } @else {
                    <button
                      type="button"
                      class="manage-outage-page__pagination-page"
                      [class.manage-outage-page__pagination-page--active]="pagination.page_no === page"
                      [disabled]="isLoading"
                      (click)="goToPage(page)"
                    >
                      {{ page }}
                    </button>
                  }
                }
              </div>

              <button type="button" class="app-button app-button--secondary manage-outage-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                Next
              </button>
            </div>

            <label class="manage-outage-page__pagination-size">
              <span class="manage-outage-page__pagination-size-label">Rows per page</span>
              <select class="app-form-input manage-outage-page__pagination-select" [formControl]="pageSizeControl">
                @for (size of pageSizeOptions; track size) {
                  <option [ngValue]="size">{{ size }}/Page</option>
                }
              </select>
            </label>
          </div>
        }
      </section>
    </main>
  </div>

  @if (outageModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-outage-modal" open>
        <div class="manage-outage-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit Outage' : modalMode === 'view' ? 'View Outage' : 'Add Outage' }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-outage-modal__close" aria-label="Close modal" (click)="closeOutageModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="outageForm" (ngSubmit)="saveOutage()">
          <div class="manage-outage-modal__body">
            <div class="manage-outage-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Entity <span class="manage-outage-modal__required">*</span></span>
                <select class="app-form-input" formControlName="mstr_entity_id">
                  <option [ngValue]="null">Select entity</option>
                  @for (entity of entities; track trackByEntityId($index, entity)) {
                    <option [ngValue]="entity.id">{{ entity.entity_name }}</option>
                  }
                </select>
                @if (isRequiredFieldInvalid('mstr_entity_id')) {
                  <section class="app-form-error manage-outage-modal__field-error">Entity is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Substation <span class="manage-outage-modal__required">*</span></span>
                <select class="app-form-input" formControlName="mstr_substation_id" [disabled]="!outageForm.get('mstr_entity_id')?.value || isSubstationLoading">
                  <option [ngValue]="null">Select substation</option>
                  @for (substation of substations; track trackBySubstationId($index, substation)) {
                    <option [ngValue]="substation.id">{{ substation.station_name }}{{ substation.station_code ? ' (' + substation.station_code + ')' : '' }}</option>
                  }
                </select>
                @if (isRequiredFieldInvalid('mstr_substation_id')) {
                  <section class="app-form-error manage-outage-modal__field-error">Substation is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Outage Type<span class="manage-outage-modal__required">*</span></span>
                <select class="app-form-select" formControlName="outage_type">
                  <option [ngValue]="''">Select outage type</option>
                  @for (typeOption of outageTypeOptions; track typeOption.value) {
                    <option [ngValue]="typeOption.value">{{ typeOption.label }}</option>
                  }
                 
                </select>
                @if (isRequiredFieldInvalid('outage_type')) {
                  <section class="app-form-error manage-outage-modal__field-error">Outage type is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Outage Start <span class="manage-outage-modal__required">*</span></span>
                <input class="app-form-input" type="datetime-local" formControlName="outage_start" />
                @if (isRequiredFieldInvalid('outage_start')) {
                  <section class="app-form-error manage-outage-modal__field-error">Outage start is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Expected End</span>
                <input class="app-form-input" type="datetime-local" formControlName="expected_end" [attr.min]="getOutageMinDateTime()" />
                @if (isDateFieldInvalid('expected_end')) {
                  <section class="app-form-error manage-outage-modal__field-error">Expected End must be greater than Outage Start.</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Actual Revival</span>
                <input class="app-form-input" type="datetime-local" formControlName="actual_revival" [attr.min]="getOutageMinDateTime()" />
                @if (isDateFieldInvalid('actual_revival')) {
                  <section class="app-form-error manage-outage-modal__field-error">Actual Revival must be greater than Outage Start.</section>
                }
              </label>

              <label class="app-form-field manage-outage-modal__span-2">
                <span class="app-form-label">Reason</span>
                <textarea class="app-form-input manage-outage-modal__textarea" rows="4" placeholder="Optional reason" formControlName="reason"></textarea>
              </label>
            </div>
          </div>

          <div class="manage-outage-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeOutageModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedOutage) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-outage-delete">
        <div class="manage-outage-delete__header">
          <div class="manage-outage-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Outage</h3>
            <p>This action will deactivate the outage record</p>
          </div>
        </div>

        <p class="manage-outage-delete__copy">
          Are you sure you want to delete <strong>{{ selectedOutage.station_name }}</strong> outage?
        </p>

        <div class="manage-outage-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }
</div>
